<mat-expansion-panel #panel expanded class="bordered" [disabled]="disabled" *ngIf="attachments.length || updateForm.length else panelButton">
   <mat-expansion-panel-header>
      <mat-panel-title>Attachments</mat-panel-title>

      <div (click)="$event.stopPropagation()" *ngIf="panel.expanded" class="common-mr1em">
         <ng-container *ngTemplateOutlet="addButton"></ng-container>

         <lib-save-button [state]="attachmentService.savingState" [disabled]="updateForm.invalid" (save)="save.emit(updateForm.value)" [showCancel]="true" (cancel)="updateForm.clear()"></lib-save-button>
      </div>
   </mat-expansion-panel-header>

   <lib-attachment-create *ngIf="updateForm.length" [form]="updateForm" [attachmentTypesEnum]="attachmentTypesEnum"></lib-attachment-create>

   <lib-attachment-select [attachments]="attachments"></lib-attachment-select>
</mat-expansion-panel>

<button mat-button color="accent" class="expansion-add-button" *ngIf="!attachments && allowNewAttachments" (click)="uploader.click()">
   <mat-icon>add</mat-icon> ADD ATTACHMENT
</button>

<input hidden type="file" #uploader (change)="attachFile($event)" [accept]="attachmentService.allowedMimetypes.join(', ')" multiple="true">

<ng-template #addButton>
   <div *ngIf="allowNewAttachments else blockedIcon">
      <div *ngIf="attachmentService.savingState !== 'saving' && !updateForm.length" (click)="uploader.click()">
         <button mat-button color="accent" *ngIf="!breakpoints.xsmall else iconButton">
            <mat-icon>add</mat-icon> ADD ATTACHMENT
         </button>
      </div>
   </div>

   <ng-template #iconButton>
      <button mat-icon-button color="accent">
         <mat-icon>add</mat-icon>
      </button>
   </ng-template>
</ng-template>

<ng-template #panelButton>
   <button mat-button color="accent" class="expansion-add-button" (click)="uploader.click()">
      <mat-icon>add</mat-icon> ADD ATTACHMENT
   </button>
</ng-template>

<ng-template #blockedIcon>
   <mat-icon color="alert" [matTooltip]="'This type of update is blocked right now.'">warning</mat-icon>
</ng-template>
